var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownload = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.4999 12.75V16.0833C17.4999 16.5254 17.3243 16.9493 17.0117 17.2618C16.6992 17.5744 16.2752 17.75 15.8332 17.75H4.16654C3.72452 17.75 3.30059 17.5744 2.98803 17.2618C2.67547 16.9493 2.49988 16.5254 2.49988 16.0833V12.75",
  stroke: "#408996",
  strokeWidth: 1.99861,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.83325 8.58398L9.99992 12.7507L14.1666 8.58398",
  stroke: "#408996",
  strokeWidth: 1.99861,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 12.75V2.75",
  stroke: "#408996",
  strokeWidth: 1.99861,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download.f4797544.svg";
export { ForwardRef as ReactComponent };